// 小米全搜天气添加广告
export default {
  "m-qs.comfortweather.com": {
    ad1: [
      // <!--首屏广告-->
      {
        type: "adx",
        id: "div-gpt-ad-1779874362473-0",
        slot: "/23161678951/mi_qs_weather_20260527_view_1",
        // rect: [320, 100],
        // style: {
        //   minWidth: "320px",
        //   minHeight: "100px",
        // },
        rect: [300, 250],
        style: {
          minWidth: "300px",
          minHeight: "250px",
        },
        position: "position-08",
      },
      // <!--底部锚定 floorad-->
      {
        type: "anchor",
        slot: "/23161678951/mi_qs_weather_20260527_floorad",
        position: "position-01",
      },
    ],
    ad2: [
      {
        type: "adx",
        id: "div-gpt-ad-1779874397657-0",
        slot: "/23161678951/mi_qs_weather_20260527_view_2",
        rect: [300, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-09",
      },
      {
        type: "adx",
        id: "div-gpt-ad-1779874426361-0",
        slot: "/23161678951/mi_qs_weather_20260527_view_3",
        rect: [300, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-13",
      },
      {
        type: "adx",
        id: "div-gpt-ad-1779874496669-0",
        slot: "/23161678951/mi_qs_weather_20260527_view_4",
        rect: [300, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-14",
      },
      {
        type: "adx",
        id: "div-gpt-ad-1779874516281-0",
        slot: "/23161678951/mi_qs_weather_20260527_view_5",
        rect: [300, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-15",
      },
    ],
    adInterstitial: [
      {
        type: "interstitial",
        slot: "/23161678951/mi_qs_weather_20260527_interstitial",
      },
    ],
  },
};
